import React, { Component } from 'react'
import { connect } from 'react-redux'
import actions from '../actions/index'
import Skeleton from 'react-loading-skeleton'
import { EmailAlertSetup } from './EmailAlertSetup'
import { Redirect } from 'react-router-dom'
import { confirmAlert } from 'react-confirm-alert'
import { validateName } from '../utils/validations'
import { currentUtcDateTime } from '../utils/dateTime'
import { pushContentToMatomo } from '../utils/matomo'

export class SaveSearch extends Component {

    constructor(props) {
        super(props);

        this.state = this.initialState;
    }

    get initialState() {
        return {
            id: 0,
            notFound: false,
            name: this.props.location.state ? this.props.location.state.searchTerm.substring(0, 48) : '',
            instantAlert: false,
            dailyWrapUpAlert: false,
            dailyWrapUpAlertTime: '-1',
            searchUrl: this.props.location.state ? this.props.location.state.searchUrl : '',
            errors: {},
            fetching: false,
            successMessage: ''
        }
    }

    updateInitialState(currentSavedSearchId) {
        let currentSavedSearch = this.props.userSearches.savedSearches.filter(x => x.id === Number(currentSavedSearchId))
       
        if (currentSavedSearch.length !== 0) {
            this.setState({
                ...this.state,
                notFound: false,
                id: currentSavedSearch[0].id,
                name: currentSavedSearch[0].name,
                instantAlert: currentSavedSearch[0].savedSearchInstantAlert,
                dailyWrapUpAlert: currentSavedSearch[0].savedSearchAlert,
                dailyWrapUpAlertTime: currentSavedSearch[0].savedSearchAlertTime,
                searchUrl: currentSavedSearch[0].url               
            })

            this.bindControls()
        }
        else
        {
            this.setState({
                ...this.state,
                notFound: true               
            })
        }
    }

    bindControls() {
        if(this.props.match.params.id != undefined && this.props.location.state != undefined)
        {
            this.savedSearchName.value = this.state.name
        }        
    }

    componentDidMount() {
        if (this.props.user) {
            this.fetchSavedSearches()
        }

        window.scrollTo(0, 0)

        if (this.props.location.state) {
            if (this.props.location.state.dateTo !== '') {
                confirmAlert({
                    title: 'Your search includes a date filter',
                    message: "You have specified a 'Date To' filter, so results will\n only include those up to this date. To ensure your\n search shows the latest content, you should remove\nthe 'Date To' filter.\n\nDo you wish to save your search with the 'Date To'\nfilter applied?",
                    buttons: [
                        {
                            label: 'Yes',
                            onClick: () => { }
                        },
                        {
                            label: 'Cancel',
                            onClick: () => {
                                window.location.href = this.props.location.state.searchUrl
                            }
                        }
                    ]
                })
            }
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.match.params.id !== prevProps.match.params.id) {
            this.fetchSavedSearches()
        }

        const errors = this.state.errors
        if (errors !== prevState.errors && Object.keys(errors).length > 0) {
            window.scrollTo(0, 0);
        }
    }

    fetchSavedSearches = () => {
        this.setState({ fetching: true })         
        this.props.onFetch().then(() => {
            this.setState({ fetching: false })         
            if (this.props.match.params.id !== undefined) {               
                    this.updateInitialState(this.props.match.params.id)            
            }
        })
    }

    isValid = () => {
        let errors = {};
        if (this.state.dailyWrapUpAlert && (!this.state.dailyWrapUpAlertTime || this.state.dailyWrapUpAlertTime == '-1')) {
            errors["dailyAlertTime"] = 'If you choose an alert type of "Daily Wrap-up", you must set a delivery time.'
        }
        const savedSearchNameValidationError = validateName(this.state.name, 'saved search')

        if (savedSearchNameValidationError) {
            errors["savedSearchName"] = savedSearchNameValidationError
        }
        this.setState({ errors: errors })
        if (Object.keys(errors).length > 0) {
            return false
        }
        return true
    }

    save = (e) => {
        //Save only if form is valid
        if (this.isValid()) {

            let maxId = Math.max(...this.props.userSearches.savedSearches.map(o => o.id), 0)

            maxId = Number(maxId) < 10000 ? 10000 : Number(maxId)

            let newSavedSearchObj =
            {
                id: this.state.id === 0 ? (Number(maxId) + 1) : this.state.id,
                name: this.state.name.trim(),       
                savedSearchInstantAlert: this.state.instantAlert,
                savedSearchAlert: this.state.dailyWrapUpAlert,
                savedSearchAlertTime: !this.state.dailyWrapUpAlert && this.state.dailyWrapUpAlertTime == '-1' ? '18:00' : this.state.dailyWrapUpAlertTime,
                url: this.state.searchUrl.replace(new RegExp('&sortOrder' + "=\\w+"), "&sortOrder=Newest").replace(new RegExp('&pgn' + "=\\w+"), "").replace("?&", "?").replace("&&", "&"),
                dateModified: currentUtcDateTime()
            }

            let finalSavedSearches
            let successMsg = ''

            // create new saved search
            if (this.state.id === 0) {
                this.setState({ id: Number(maxId) + 1 })

                finalSavedSearches = [...this.props.userSearches.savedSearches, newSavedSearchObj]

                successMsg = 'Your saved search and any selected alerts have been successfully created.'

                var contextData = newSavedSearchObj
    
                pushContentToMatomo('search_savenew', 'content', 'search_results', 'click', 'Save Search', contextData)
            }
            else {  // edit saved search
                finalSavedSearches = this.props.userSearches.savedSearches.map(search =>
                    search.id === this.state.id ?
                        newSavedSearchObj : search);

                successMsg = 'Edits to your saved search and/or alerts have been successfully saved.'

                var contextData = {
                    "savedSearchId": this.state.id,
                    "savedSearchName": this.state.name.trim()
                }
    
                pushContentToMatomo('savedsearch_itemedit', 'personalize', 'alerts', 'click', 'edit', contextData)
            }

            const request = () => {
                return {
                    ...this.props.userSearches,
                    savedSearches: finalSavedSearches
                }
            }

            this.props.onSubmit(request()).then(() => {
                if (this.props.userSearches.error === '') {
                    this.setState({ successMessage: successMsg })
                }
                else {
                    this.props.userSearches.error = ''
                }
            })
        }
    }

    updateEmailAlertSetupState = (instantAlert, dailyWrapUpAlert, dailyWrapUpAlertTime) => {
        //reset the validation error 
        if (dailyWrapUpAlertTime || dailyWrapUpAlertTime != '-1') {
            let errorObj = this.state.errors
            delete errorObj.dailyAlertTime
            this.setState({ errors: errorObj })
        }
        this.setState(
            {
                instantAlert: instantAlert,
                dailyWrapUpAlert: dailyWrapUpAlert,
                dailyWrapUpAlertTime: !dailyWrapUpAlert && dailyWrapUpAlertTime == '-1' ? '18:00' : dailyWrapUpAlertTime
            }
        )
    }

    updateNameState = (e) => {
        const savedSearchName = e.target.value
        this.setState({ name: savedSearchName })
        //reset the validation error 
        const savedSearchNameValidationErrors = validateName(savedSearchName, 'saved search')
        if (!savedSearchNameValidationErrors) {
            let errorObj = this.state.errors
            delete errorObj.savedSearchName
            this.setState({ errors: errorObj })
        }
    }

    cancel = (event) => {
        event.preventDefault()

        this.props.match.params.id != undefined && this.props.match.params.id != 0 ?
            window.location.assign('/#/personalize')
            :
            this.viewSavedSearch(event)
    }

    viewSavedSearch = (event) => {
        event.preventDefault()

        window.location.assign(this.state.searchUrl)
    }

    render() {
        if (this.props.user != null) {
            if (this.props.userSearches.error != '') {
                this.props.userSearches.error = ''
                return <Redirect to='/error' />
            }
            else {
                if (this.state.fetching==false) {
                    const errors = this.state.errors
                    return (
                        this.props.match.params.id === undefined && this.props.location.state === undefined ?
                            <div className='content content-set grid-content-full'>
                                <div className='message alert alert-warning searchMessage'>
                                    Unable to create a new saved search. There are no search criteria.<br />
                            Please start by running a new search, then save the results.<br />
                                    <div className='message-buttons'>
                                        <a className='pure-button primary-action' href={`/#/home`} target='_self' >Go to Homepage</a>
                                    </div>
                                </div>
                            </div>
                            :
                            <div className='content content-set grid-content-full'>
                                {this.state.notFound ? 
                                
                                    <div className='message alert alert-warning searchMessage'>
                                        Unable to process this request. The saved search cannot be found.                              
                                        <div className='message-buttons'>
                                            <a className='pure-button primary-action' href={`/#/personalize`} target='_self' >View Saved Search List</a>
                                        </div>
                                    </div>
                                :
                                    <>
                                        <div className='inner-container'>
                                            {this.props.match.params.id != undefined && this.props.match.params.id != 0 ?
                                                <>
                                                    <h1 className="section-header">Edit Saved Search</h1>
                                                    <p>Change the alert settings and name for this saved search.  To adjust the filters, go to the list of saved searches on the Alerts page and click on the name of the saved search.<br /></p>
                                                </>
                                                :
                                                <>
                                                    <h1 className="section-header">Save Search</h1>                                            
                                                    <p>Create a new saved search for these results and select alerts (if required).<br /></p>
                                                </>
                                            }
                                            {Object.keys(errors).length > 0 &&

                                                <div className='alert alert-error'>
                                                    <p>{this.state.errors["dailyAlertTime"]}</p>
                                                    <p dangerouslySetInnerHTML={{ __html: this.state.errors["savedSearchName"] }}></p>
                                                </div>}
                                            <div className='line' />
                                        </div>
                                        {this.state.successMessage !== '' ?
                                            <div className='inner-container search-saved'>
                                                <br />
                                                <div className="success-wrapper">
                                                    <div className='success-icon'></div>
                                                </div>
                                                <div className="message-wrapper">
                                                    <div>
                                                        {this.state.successMessage}
                                                    </div>
                                                    <div className='message-note'>
                                                        Note: Saved searches exclude Portfolios and Press Round-ups.<br />
                                                        Please use the separate alerts for these content types
                                                    </div>
                                                    <br />
                                                    <div className='cta-action-container'>
                                                        <span title='create saved search'>
                                                            <a id='btnCreate' href={`/#/search`} name='btnCreate'
                                                                className='pure-button secondary-action' onClick={event => this.viewSavedSearch(event)}>View This Saved Search</a>
                                                        </span>
                                                        <a className='pure-button primary-action' href={`/#/personalize`} target='_self' >View Saved Search List</a>
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            <div className='inner-container saved-search-create'>
                                                <div>
                                                    <EmailAlertSetup data={this.state} callFunc={this.updateEmailAlertSetupState} parentComponent='search' />
                                                </div>
                                                <div className='line'></div>
                                                <div className="saved-search-name">
                                                    <h3>Give your saved search a meaningful name</h3>
                                                    <strong><span className='font-small'>Name (max. 48 characters)<span className='mandatory'>*</span></span></strong>
                                                    <br />
                                                    <input className={`input ${this.state.errors["savedSearchName"] ? 'error-input' : ''}`} type='text' id='savedSearchName'
                                                        ref={input => { this.savedSearchName = input }} maxLength="48"
                                                        onChange={this.updateNameState} value={this.state.name} />
                                                    <br />
                                                    <em className='font-small input-help'>Allowed characters: a-z A-Z 0-9 - . _ ( ) ' " ! : , & * [ ]</em>
                                                    <br />
                                                    <br />
                                                    <span className='font-small'><span className='mandatory'>*</span> Denotes a required field</span>
                                                </div>
                                                <div className='inner-container button-container cta-action-container'>
                                                    <a className='pure-button secondary-action' href='#' onClick={event => this.cancel(event)} target='_self' >Cancel</a>
                                                    <button id='SaveButton' name='SaveButton' className='pure-button primary-action' onClick={event => this.save(event)}>Save</button>
                                                </div>
                                            </div>
                                        }
                                    </>
                                }
                            </div>               
                    )
                } else {
                    return (
                        <div className='content content-set grid-content-full'>
                            <Skeleton count={15} />
                        </div>
                    )
                }
            }
        } else {
            return (<div />)
        }
    }
}

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        userSearches: state.userSearches
    }
}

const mapDispatchToProps = (dispatch) => ({
    onFetch: () => new Promise((resolve, reject) => {
        dispatch(actions.fetchSavedSearches()).then(() => {
            resolve();
        })
    }),

    onSubmit: (request) => new Promise((resolve, reject) => {
        dispatch(actions.updateSavedSearches(request)).then(() => {
            resolve();
        })
    })
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SaveSearch)